import type { CSSProperties } from 'react';

interface SliderProps {
  min: number;
  max: number;
  value?: number;
  step?: number;
  label?: string;
  className?: string;
  style?: CSSProperties;
}

export function SliderView({ min, max, value, step = 1, label, className, style }: SliderProps) {
  const displayValue = value ?? min;
  return (
    <div className={`flex flex-col gap-1${className ? ` ${className}` : ''}`} style={style}>
      {label && (
        <div className="flex justify-between text-xs text-zinc-500 dark:text-zinc-400">
          <span>{label}</span>
          <span>{displayValue}</span>
        </div>
      )}
      <input
        type="range"
        min={min}
        max={max}
        value={displayValue}
        step={step}
        readOnly
        className="w-full accent-blue-600"
      />
    </div>
  );
}
